import { FirebaseData } from "../../General/FirebaseData";


export interface BookingDataCustomField {
  id: string
  data: any
}


export default class BookingInformationData extends FirebaseData {

  title: string = "";
  bookingOwnerEmail: string = "";
  bookingOwnerPhone: string = "";
  bookingOwnerName: string = "";

  customFields: BookingDataCustomField[] = []

  setup(data: { [key: string]: any }) {
    if (typeof data.title === "string") {
      this.title = data.title;
    }
    if (typeof data.bookingOwnerEmail === "string") {
      this.bookingOwnerEmail = data.bookingOwnerEmail;
    }
    if (typeof data.bookingOwnerPhone === "string") {
      this.bookingOwnerPhone = data.bookingOwnerPhone;
    }
    if (typeof data.bookingOwnerName === "string") {
      this.bookingOwnerName = data.bookingOwnerName;
    }

    this.customFields = []
    if (typeof data.customFields === "object") {
      for (const key of Object.keys(data.customFields)) {
        this.customFields.push({
          id: key,
          data: data.customFields[key].data
        })
      }
    }

    super.setup(data);
  }
}